"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOpeningHours = getOpeningHours;
exports.getOpeningHoursSpecification = getOpeningHoursSpecification;

var _moment = _interopRequireDefault(require("moment"));

function fishermanTimeToMoment(fishrmnTime) {
  return (0, _moment["default"])(fishrmnTime.toString().padStart(4, '0'), 'HHmm');
}

function getOpeningHours(hours) {
  var HOURS_LABELS = {
    1: 'Mo',
    2: 'Tu',
    3: 'We',
    4: 'Th',
    5: 'Fr',
    6: 'Sa',
    7: 'Su'
  };

  if (hours) {
    return hours.map(function (_ref) {
      var day = _ref.day,
          open = _ref.open,
          close = _ref.close;
      var openStr = fishermanTimeToMoment(open).format('HH:mm');
      var closeStr = fishermanTimeToMoment(close).format('HH:mm');
      return "".concat(HOURS_LABELS[day], " ").concat(openStr, " - ").concat(closeStr);
    });
  }

  return undefined;
}

function getOpeningHoursSpecification(hours) {
  var DAY_OF_WEEK = {
    1: 'https://schema.org/Monday',
    2: 'https://schema.org/Tuesday',
    3: 'https://schema.org/Wednesday',
    4: 'https://schema.org/Thursady',
    5: 'https://schema.org/Friday',
    6: 'https://schema.org/Saturday',
    7: 'https://schema.org/Sunday'
  };

  if (hours) {
    return hours.map(function (_ref2) {
      var day = _ref2.day,
          open = _ref2.open,
          close = _ref2.close;
      var openStr = fishermanTimeToMoment(open).format('HH:mm:ss');
      var closeStr = fishermanTimeToMoment(close).format('HH:mm:ss');
      return {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": DAY_OF_WEEK[day],
        "opens": openStr,
        "closes": closeStr
      };
    });
  }
}